/**
 * Responsive Google Maps Zoom
 * Automatycznie zmienia zoom mapy w zależności od szerokości ekranu
 * 
 * Breakpointy:
 * - < 480px: zoom x8 (bardzo oddalony)
 * - 480-768px: zoom x5 (średnio oddalony)
 * - > 768px: oryginalny zoom
 */

(function() {
    'use strict';

    class ResponsiveMap {
        constructor() {
            this.mapIframe = document.querySelector('.section-map iframe');
            this.originalSrc = null;
            this.originalDistance = null;
            
            if (!this.mapIframe) return;
            
            this.init();
        }

        init() {
            this.originalSrc = this.mapIframe.src;
            if (!this.originalSrc) return;
            
            this.extractOriginalDistance();
            this.updateMapZoom();
            
            let resizeTimer;
            window.addEventListener('resize', () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    this.updateMapZoom();
                }, 250);
            });
        }

        extractOriginalDistance() {
            const distanceMatch = this.originalSrc.match(/!1d([\d.]+)/);
            if (distanceMatch) {
                this.originalDistance = parseFloat(distanceMatch[1]);
            } else {
                this.originalDistance = 150000;
            }
        }

        updateMapZoom() {
            const width = window.innerWidth;
            let multiplier = 1;
            
            if (width < 480) {
                multiplier = 8; // Bardzo oddalony widok na małych telefonach
            } else if (width < 768) {
                multiplier = 5; // Średnio oddalony na tabletach/większych telefonach
            }
            
            const newDistance = this.originalDistance * multiplier;
            const newSrc = this.originalSrc.replace(
                /!1d[\d.]+/,
                `!1d${newDistance}`
            );
            
            if (this.mapIframe.src !== newSrc) {
                this.mapIframe.src = newSrc;
            }
        }
    }

    // Inicjalizacja po załadowaniu DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            new ResponsiveMap();
        });
    } else {
        new ResponsiveMap();
    }

})();
